// extracted by mini-css-extract-plugin
export var actionButton = "_fb-t";
export var buttonContainer = "_fb-0";
export var buttonContainer2 = "_fb-1";
export var buttonSection = "_fb-2";
export var details = "_fb-3";
export var dropdownItem = "_fb-5";
export var dropdownItemsContainer = "_fb-4";
export var fileInput = "_fb-r";
export var headerButton = "_fb-6";
export var icon = "_fb-7";
export var input = "_fb-8";
export var macroListItem = "_fb-9";
export var mainContent = "_fb-a";
export var microText = "_fb-b";
export var modal = "_fb-w";
export var optionsButton = "_fb-c";
export var paperclip = "_fb-s";
export var pillContent = "_fb-d";
export var preview = "_fb-e";
export var preview2 = "_fb-f";
export var quillEditor = "_fb-q";
export var selectedMacro = "_fb-g";
export var sidebar = "_fb-h";
export var sidebarHeader = "_fb-j";
export var sidebarList = "_fb-i";
export var sidebarListItem = "_fb-k";
export var sidebarSearch = "_fb-l";
export var snoozeDurationWrapper = "_fb-v";
export var statusPillContainer = "_fb-m";
export var tagsContainer = "_fb-n";
export var unselectedMacro = "_fb-o";
export var variable = "_fb-u";
export var wrapper = "_fb-p";